import './index.scss';

export { default as CTShortcutTable } from './ShortcutTable'; 
export { default as CTShortcutModal } from './ShortcutModal'; 